export default "__VITE_ASSET__1187275f__"